import React, { useState, useEffect } from "react";
import { ButtonComponent } from "../elements";
import { t } from "i18next";
import moment from 'moment-timezone';


export default function CustomersTableComponent({ thead, tbody,refreshPage }) {


    const [data, setData] = useState([]);

    useEffect(()=> { setData(tbody) }, [tbody]);

    return (
        <div className="mc-table-responsive">
            <table className="mc-table">
                <thead className="mc-table-head primary">
                    <tr>
                        {thead.map((item, index) => (
                            <th key={ index }>{ item }</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {data?.map((item, index) => (
                        <tr key={ index }> 
                            <td title={ item.id }>{ item.id }</td>
                            <td title={ item.name }>
                                <div className="mc-table-profile">
                                    <p>{ item.name }</p>
                                </div>
                            </td>
                            <td title={ item.email }>{ item.email }</td>
                            <td title={ item.type }>{ item.type }</td>
                            <td title={ item.is_blocked }>{ item.is_blocked?t('blocked'):t('clear') }</td>

                            <td title={ item.created }>{ moment.utc(item.created_at).local().format('yyyy-MM-DD HH:mm:ss') }</td>
                            <td>
                                <div className="mc-table-action">
                                    {/* <AnchorComponent to="/user-profile" title="View" className="material-icons view">{ "visibility" }</AnchorComponent> */}
                                    <ButtonComponent title="Edit" className="material-icons edit" onClick={()=> window.location.href="/customer-account/"+item.id}>{ "edit" }</ButtonComponent>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

           
            
        </div>
    )
}